import React, { useEffect, useState } from "react";
import { BootstrapModal } from "../BootstrapModal/Modal";
import { CgClose } from "react-icons/cg";
import Button from "../Button/Button";
import Typogaphy from "../Typography/Typography";
import { useSwitchAction } from "../../hooks/useCrm";

export const SwitchingActionModal = ({ show, handleClose, activityId }) => {
  const [button] = useState(false);
  const [actionId, setActionId] = useState();
  useEffect(() => {
    setActionId(activityId);
  }, [activityId]);
  const { mutateAsync: SwitchAction, isLoading: SwitchActionLoading } =
    useSwitchAction();
  const handleSwitchAction = async (id) => {
    await SwitchAction({ IdActivityCrm: id });
  };
  return (
    <BootstrapModal
      modaltitle="تغییر وضعیت فعالیت"
      handleClose={handleClose}
      show={show}
      moreButton={button}
      size="md"
      closebutton={
        <Button style={{ width: "40px", border: "none" }} onclick={handleClose}>
          <CgClose />
        </Button>
      }
    >
      <div className="row">
        <div className="col-12">
          <Typogaphy size="14px">آیا مطمئن هستید؟</Typogaphy>
        </div>
        <div className="col-12 d-flex justify-content-end">
          <Button
            bgColor="#009ef7"
            color="#fff"
            small="60px"
            style={{ padding: "4px" }}
            onclick={() => {
              handleSwitchAction(actionId);
              handleClose();
            }}
          >
            بله
          </Button>
          <Button
            bgColor="#f1416c"
            color="#fff"
            small="60px"
            style={{ padding: "4px", marginRight: "10px" }}
            onclick={handleClose}
          >
            خیر
          </Button>
        </div>
      </div>
    </BootstrapModal>
  );
};
